import React, { useState, useEffect } from "react";
import Footerweb from "../../components/layout/footer/Footerweb";
import {
  buttonName,
  commonValidationMsg,
  emailTemplateGocardless,
  mail,
  responseStatus
} from "../../locales/en";
import {
  FaFile,
  FaFilePdf,
  FaFileImage,
  FaRegFileWord,
  FaFileExcel
} from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import "./templateMail.scss";
import publicAxios from "../../utils/publicAxios";
import {
  getEmailTemplateCaptureUrl,
  getEmailTemplatePayNowUrl
} from "../../utils/constants/apiEndPoints";
import Headerweb from "../../components/layout/header/Headerweb";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";

const PaymentNow = () => {
  const [fileData, setFileData] = useState(null);
  const [fileError, setFileError] = useState("");
  const [dataError, setDataError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [getData, setGetData] = useState({});
  const [payNowData, setPayNowData] = useState(null);
  const [FileIcon, setFileIcon] = useState(() => FaFile);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("uuid");
  const UUIDNumber = getData?.uuid;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 5 * 1024 * 1024;

    if (file) {
      if (file.size > maxSize) {
        setFileError(commonValidationMsg?.fileLimitError);
        setFileData(null);
        setFileIcon(() => FaFile);
      } else {
        setFileError("");
        setFileData(file);
        // choose icon dynamically
        if (file.type.includes("pdf")) setFileIcon(() => FaFilePdf);
        else if (file.type.includes("image")) setFileIcon(() => FaFileImage);
        else if (file.type.includes("word")) setFileIcon(() => FaRegFileWord);
        else if (file.type.includes("excel")) setFileIcon(() => FaFileExcel);
        else setFileIcon(() => FaFile);
      }
    } else {
      setFileError(commonValidationMsg?.fileUpload);
      setFileData(null);
      setFileIcon(() => FaFile);
    }
  };

  const handleSubmit = async () => {
    let hasError = false;

    if (!fileData) {
      setFileError(commonValidationMsg?.fileUpload);
      hasError = true;
    }

    if (fileError) {
      hasError = true;
    }

    if (hasError) {
      return;
    }

    try {
      setUploadLoading(true);
      const form = new FormData();
      form.append("evidenceFile", fileData);
      const res = await publicAxios.post(
        getEmailTemplatePayNowUrl(UUIDNumber),
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      setPayNowData(res?.data?.data?.message);
    } catch (error) {
      showToast(error?.response?.data?.errors, responseStatus?.error);
    } finally {
      setUploadLoading(false);
    }
  };

  useEffect(() => {
    const handleGetPayNow = async () => {
      try {
        setLoading(true);
        setDataError(false);
        const response = await publicAxios.get(
          getEmailTemplatePayNowUrl(token)
        );
        const responseData = response?.data?.data;
        setGetData(responseData);
      } catch (error) {
        setDataError(true);

        showToast(error?.response?.data?.message, showToastType.error);
      } finally {
        setLoading(false);
      }
    };
    handleGetPayNow();
  }, []);

  useEffect(() => {
    const handleGetPayNow = async () => {
      try {
        const payload = {
          referrer: "pay_now"
        };
        await publicAxios.post(getEmailTemplateCaptureUrl(UUIDNumber), payload);
      } catch (error) {
        showToast(error?.response?.data?.message, showToastType.error);
      }
    };
    if (getData && getData?.uuid) {
      handleGetPayNow();
    }
  }, [getData]);

  if (loading) {
    return (
      <div className="spinner-wrap bg-light loader_absolute">
        <div className="spinner-border custom-spinner-color" />
      </div>
    );
  }

  return (
    <div className="date-for-payment-wrap">
      <Headerweb />
      <div className="refrral-banner-section" />
      <div className="container mt-5 mb-5">
        {dataError ? (
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="date-for-payment-box mb-4">
                <h3 className="mb-3">
                  {emailTemplateGocardless?.paymentNow?.errorTitle}
                </h3>
                <p>
                  {`${emailTemplateGocardless?.paymentNow?.errorText} `}
                  <a href={`mailto:${mail}`}>{mail}</a>
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="row justify-content-center">
            {payNowData ? (
              <div className="col-md-8 pb-3 pt-3">
                <div className="date-for-payment-box mb-4">
                  <h3>{payNowData}</h3>
                </div>
              </div>
            ) : (
              <div className="col-md-8">
                <div className="date-for-payment-box mb-4">
                  <h1 className="mb-3">
                    {emailTemplateGocardless?.paymentNow?.title}
                  </h1>
                  <p className="mb-3">
                    <strong>{getData?.totalOwing}</strong>
                    {` ${emailTemplateGocardless?.paymentNow?.title1}`}
                  </p>
                  <p>
                    <strong>
                      {getData?.accountNumber
                        ?.split("\n")
                        .map((line, index, array) => (
                          <React.Fragment key={index}>
                            {line}
                            {index !== array.length - 1 && <br />}
                          </React.Fragment>
                        ))}
                    </strong>
                  </p>
                  <p>{emailTemplateGocardless?.paymentNow?.text1}</p>
                </div>
                <div className="date-for-payment-box mb-3">
                  <label htmlFor="fileUpload" className="form-label">
                    {emailTemplateGocardless?.paymentNow?.bankLabel}
                  </label>
                  <div className="formInput">
                    <input
                      type="file"
                      id="fileUpload"
                      name="file"
                      accept="image/*,.pdf,.doc,.docx"
                      onChange={handleFileChange}
                    />
                    {fileData && (
                      <p className="d-flex align-items-center text-success mt-2">
                        <FileIcon className="me-1" />
                        {fileData.name}
                      </p>
                    )}
                    {fileError && (
                      <p className="text-danger mt-2">{fileError}</p>
                    )}
                  </div>
                </div>

                <div className="date-for-payment-box mb-3">
                  <button
                    onClick={handleSubmit}
                    className="btn btn-primary submit"
                    type="button"
                  >
                    {uploadLoading ? buttonName?.loading : buttonName?.submit}
                  </button>
                </div>

                <div className="date-for-payment-box mb-3">
                  <p>
                    {`${emailTemplateGocardless?.paymentNow?.text2}`} <br />
                    {`${emailTemplateGocardless?.paymentNow?.text3} `}
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <Footerweb />
    </div>
  );
};

export default PaymentNow;
